import { createSlice } from '@reduxjs/toolkit'
import { fetchQrCart, payWithApple, payWithGoogle } from '../thunks/qr'

export const mainSlice = createSlice({
  name: 'main',
  initialState: {
    loading: false, // true
  },
  reducers: {
    // setA11yColorScheme: (state, { payload }) => {
    //   state.a11yColorScheme = payload
    // },
  },
  extraReducers: (builder) => {
    const loadingTrueCases = [fetchQrCart.pending, payWithGoogle.pending, payWithApple.pending]
    const loadingFalseCases = [
      fetchQrCart.fulfilled,
      fetchQrCart.rejected,
      payWithGoogle.fulfilled,
      payWithGoogle.rejected,
      payWithApple.fulfilled,
      payWithApple.rejected,
    ]

    for (const action of loadingTrueCases) {
      builder.addCase(action, (state, action) => {
        state.loading = true
      })
    }

    for (const action of loadingFalseCases) {
      builder.addCase(action, (state, action) => {
        // console.log(action)
        state.loading = false
      })
    }

    // builder
    //   .addCase(fetchQrCart.pending, (state, action) => {
    //     state.loading = true
    //   })
    //   .addCase(fetchQrCart.fulfilled, (state, { payload }) => {
    //     state.loading = false
    //   })
    //   .addCase(fetchQrCart.rejected, (state, action) => {
    //     state.loading = false
    //   })
  },
})

// Action creators are generated for each case reducer function
// export const { setA11yColorScheme } = mainSlice.actions

export const mainSelector = (state) => state.main
export const mainReducer = mainSlice.reducer
